import React, { createContext, useEffect, useState, useContext } from 'react';
import { auth } from '../firebase/firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);

      // ✅ Save user email for access control
      if (user?.email) {
        localStorage.setItem('user', JSON.stringify({ email: user.email }));
      } else {
        localStorage.removeItem('user');
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = (user) => {
    setCurrentUser(user);
  };

  const logout = async () => {
    await signOut(auth);
    setCurrentUser(null);
    localStorage.removeItem('user'); // ✅ clear email on logout
  };

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

// ✅ Use this in any component to access user info
export const useAuth = () => {
  return useContext(AuthContext);
};
